import { cabinBaggage, checkInBaggage, secondBaggagePerTraveler } from '@eti/products';

const BAGGAGE_PRODUCTS_IDS = [cabinBaggage.id, checkInBaggage.id, secondBaggagePerTraveler.id];

export const getTravelersWithBaggageProductsOnly = (travelers = []) =>
  travelers.map((traveler) => ({
    ...traveler,
    products: (traveler.products || []).filter((product) =>
      BAGGAGE_PRODUCTS_IDS.includes(Number(product.id)),
    ),
  }));

export const getTravelerCheckedBaggageSummary = (checkedBaggageSummary, id) =>
  id && checkedBaggageSummary && checkedBaggageSummary.length
    ? checkedBaggageSummary.find(({ travelerId }) => travelerId === id)
    : null;
